<template>
  <div>
    <paper v-if="show" ref="paperRef"
           :cardHeight="'100%'"
           :cardScrollHeight="'100%'"
           :index="query.paperItemId"
           :pointId="query.pointId"
           :taskId="query.taskId"
           :flag="index"
           :pointName="pointName"
           :projectId="projectId"
           :locationSignInGroups="locationSignInGroups"
           :locationSignIns="locationSignIns"
           @on-tempSave="tempSave"
           @auto-on-tempSave="autoTempSave"
           @on-location-sign-in="goLocationSignIn"
           @on-submit="submitAnswer"></paper>
    <location-sign-in-drawer
      v-model="locationDrawerVisible"
      :groups="locationSignInGroups"
      :signIns="locationSignIns"
      :targetGroup="targetLocationSignInGroup"
      :editable="index !== 2"
      @save="saveLocationSignIns"
    />
  </div>
</template>

<script>
import Paper from "./paper";
import LocationSignInDrawer from './components/LocationSignInDrawer'
import _ from "lodash";
import {paperNews, submit} from '@/api/module/task/taskApi'
import {Notify} from "vant";
import { getRequiredLocationSignInGroups } from '@/config/locationSignIn'
import {
  buildLocationSignInKey,
  getLocationSignIns,
  removeLocationSignIns,
  setLocationSignIns
} from '@/api/module/task/locationSignInStore'

export default {
  name: "index",
  components: {Paper, LocationSignInDrawer},
  data() {
    return {
      show: false,
      query: {
        taskId: null ,
        pointId: null,
        paperItemId: null,
      },
      questionData: null,
      answerData: null,
      index: 0,
      pointName: '',
      projectId: null,
      locationSignInGroups: [],
      locationSignIns: [],
      locationDrawerVisible: false,
      targetLocationSignInGroup: null,
    }
  },
  methods: {
    init() {
      console.log(this.$route.params)
      const $params = this.$route.params
      this.query.taskId = $params?.taskId
      this.query.pointId = $params?.pointId
      this.query.paperItemId = $params?.paperItemId
      this.index = $params?.index
      this.pointName = $params?.pointName
      this.show = true
      this.loadPaper()
    },

    currentGroupList(groupList, oldPaperList) {
      groupList.forEach((group) => {
        let paperList = []
        group.paperIds.forEach((id) => {
          paperList.push(oldPaperList.find(item => item.id === id))
        })
        if (paperList.length) {
          paperList = _.sortBy(paperList,
            [o => o.paperNum.split('-')[0],o => Number(o.paperNum.split('-')[1])])
        }
        group.paperList = paperList
      })
      return groupList
    },
    surplusPaperList(groupList, paperList) {
      let groupPaperIds = groupList.map((item) => item.paperIds)
      groupPaperIds = _.flattenDepth(groupPaperIds, 2)
      groupPaperIds = _.uniq(groupPaperIds);
      let surplusPaperList =  _.differenceWith(paperList, groupPaperIds, (arrVal, othVal) => {
        return arrVal.id === othVal
      })
      if (surplusPaperList && surplusPaperList.length) {
        surplusPaperList = _.sortBy(surplusPaperList,
          [o => o.paperNum.split('-')[0],o => Number(o.paperNum.split('-')[1])])
      }
      return surplusPaperList
    },
    loadPaper() {
      paperNews(this.query).then((res) => {
        let tempData = undefined
        if(this.index!==2){
          tempData = JSON.parse(localStorage.getItem('tempData:'+this.query.paperItemId+'-'+this.query.taskId+'-'+this.query.pointId))
        }
        console.log('temp',tempData)

        const data = res.data
        this.projectId = data.projectId
        if(tempData!==null&&tempData!==''&&tempData!==undefined){
          data.answerData = tempData.data
          data.answer = true
          data.recordingId = tempData.recordingId
        }
        const questionData = data.questionData
        const currentGroupList = this.currentGroupList(questionData.groupList, questionData.paperList);
        const surplusPaperList = this.surplusPaperList(questionData.groupList, questionData.paperList);
        this.locationSignInGroups = getRequiredLocationSignInGroups(data.projectId, currentGroupList)
        this.locationSignIns = this.loadLocationSignIns(data.locationSignIns)
        console.log('answerData',data.answerData)
        this.$refs.paperRef.setData({
          currentGroupList: currentGroupList,
          surplusPaperList: surplusPaperList,
          logicList: questionData.logicList,
          isHeader: false,
          answer: data.answer,
          answerData: data.answerData,
          recordingId: data.recordingId,
          taskPointDetailsId: data.taskPointDetailsId,
          type: data.type
        })
        console.log(data)
      })
    },
    locationStorageKey() {
      return buildLocationSignInKey(this.query)
    },
    loadLocationSignIns(serverSignIns) {
      const localSignIns = getLocationSignIns(this.locationStorageKey())
      if (localSignIns && localSignIns.length) {
        return localSignIns
      }
      return (serverSignIns || []).map(item => {
        const configGroup = this.locationSignInGroups.find(group => String(group.id) === String(item.groupId))
        const locationParts = (item.location || '').split(',')
        return {
          groupId: item.groupId,
          groupName: item.groupName || (configGroup ? configGroup.classifyName : ''),
          location: item.location,
          longitude: locationParts[0] || '',
          latitude: locationParts[1] || '',
          address: item.address || ''
        }
      })
    },
    tempSave(data, recordingId){
      console.log('暂存数据',data);
      console.log('暂存录音数据',recordingId);
      if(this.index===2){
        return
      }
      let tempData = {
        data: data,
        recordingId: recordingId
      }
      localStorage.setItem('tempData:'+this.query.paperItemId+'-'+this.query.taskId+'-'+this.query.pointId,JSON.stringify(tempData))
      localStorage.setItem('newTempData',this.query.paperItemId+'-'+this.query.taskId+'-'+this.query.pointId)
      Notify({ type: 'success', message: '保存成功!' });
    },
    goLocationSignIn(data, recordingId, targetGroup) {
      if(this.index!==2){
        let tempData = {
          data: data,
          recordingId: recordingId
        }
        localStorage.setItem('tempData:'+this.query.paperItemId+'-'+this.query.taskId+'-'+this.query.pointId,JSON.stringify(tempData))
        localStorage.setItem('newTempData',this.query.paperItemId+'-'+this.query.taskId+'-'+this.query.pointId)
      }
      this.targetLocationSignInGroup = targetGroup || null
      this.locationDrawerVisible = true
    },
    saveLocationSignIns(signIns) {
      this.locationSignIns = this.filterLocationSignIns(signIns, this.locationSignInGroups)
      setLocationSignIns(this.locationStorageKey(), this.locationSignIns)
    },
    filterLocationSignIns(signIns, requiredGroups) {
      const requiredGroupIds = (requiredGroups || []).map(group => String(group.id !== undefined && group.id !== null ? group.id : group.classifyName))
      return (signIns || []).filter(item => {
        return item && item.location && requiredGroupIds.includes(String(item.groupId))
      })
    },
    autoTempSave(data, recordingId){
      console.log('暂存数据',data);
      console.log('暂存录音数据',recordingId);
      if(this.index===2){
        return
      }
      let tempData = {
        data: data,
        recordingId: recordingId
      }
      localStorage.setItem('tempData:'+this.query.paperItemId+'-'+this.query.taskId+'-'+this.query.pointId,JSON.stringify(tempData))
      localStorage.setItem('newTempData',this.query.paperItemId+'-'+this.query.taskId+'-'+this.query.pointId)
    },
    submitAnswer(data, recordingId, requiredLocationGroups) {
      const submitLocationSignIns = this.filterLocationSignIns(this.locationSignIns, requiredLocationGroups || [])
      submit({
        answerString: JSON.stringify(data),
        itemId: this.query.paperItemId,
        taskId: this.query.taskId,
        pointId: this.query.pointId,
        recordingId: recordingId??null,
        locationSignIns: submitLocationSignIns.length ? JSON.stringify(submitLocationSignIns) : null
      }).then(res => {
        Notify({ type: 'success', message: '提交成功!' });
        localStorage.removeItem('tempData:'+this.query.paperItemId+'-'+this.query.taskId+'-'+this.query.pointId)
        const newTempDataStr =localStorage.getItem('newTempData');
        if(newTempDataStr){
          const newTempData = newTempDataStr.split('-')
          if(this.query.paperItemId.toString()===newTempData[0]&&this.query.taskId.toString()===newTempData[1]&&this.query.pointId.toString()===newTempData[2]){
            localStorage.removeItem('newTempData')
          }
        }
        removeLocationSignIns(this.locationStorageKey())
        this.$router.push({name:'homepage'})
      })
    }
  },
  mounted() {
    console.log('init')
    this.init()
  }
}
</script>

<style lang="less" scoped>
/deep/.van-nav-bar__right{
  span{
    color:#FFFFFF;
    font-size:20px;
    font-weight: bold;
  }
}
</style>
